// extracted by mini-css-extract-plugin
export var input = "Slider-module--input--eeCaR";
export var inputLabel = "Slider-module--inputLabel--T3vEx";
export var label = "Slider-module--label--+UIOp";
export var root = "Slider-module--root--V1cPj";
export var slider = "Slider-module--slider--Tpfab";